import { Directive, ElementRef, EventEmitter, NgZone, OnDestroy, OnInit, Output, Renderer2, inject } from '@angular/core';
import Hammer from 'hammerjs';

@Directive({
  selector: '[hammerLongPress]',
  standalone: true,
})
export class HammerLongPressDirective implements OnInit, OnDestroy {
  @Output() longPressStart = new EventEmitter<void>();
  @Output() longPressEnd = new EventEmitter<void>();
  @Output() shortTap = new EventEmitter<void>();

  private el = inject(ElementRef<HTMLElement>);
  private zone = inject(NgZone);
  private renderer = inject(Renderer2);

  private hammer?: HammerManager;
  private removeListeners: Array<() => void> = [];

  private isPressing = false;
  private longPressTriggered = false;

  ngOnInit(): void {
    const nativeEl = this.el.nativeElement;

    const manager = new Hammer.Manager(nativeEl, {
      touchAction: 'manipulation',
    });

    manager.add(
      new Hammer.Press({
        event: 'press',
        time: 750,
        threshold: 10,
      })
    );

    manager.on('press', () => {
      console.log("Pressing", this.isPressing)
      this.zone.run(() => {
        if (this.isPressing) 
            return;

        this.isPressing = true;
        this.longPressTriggered = true;
        this.longPressStart.emit();
      });
    });

    this.hammer = manager;

    const end = () => {
      this.zone.run(() => {
        if (!this.isPressing) 
            return;

        this.isPressing = false;
        this.longPressEnd.emit();

        // pequeño delay para que el click nativo posterior no haga toggle
        queueMicrotask(() => {
          this.longPressTriggered = false;
        });
      });
    };

    const clickHandler = (ev: Event) => {
      this.zone.run(() => {
        if (this.longPressTriggered) {
          ev.preventDefault();
          ev.stopPropagation();
          return;
        }

        this.shortTap.emit();
      });
    };

    this.removeListeners.push(
      this.renderer.listen(nativeEl, 'touchend', end),
      this.renderer.listen(nativeEl, 'touchcancel', end),
      this.renderer.listen(nativeEl, 'pointerup', end),
      this.renderer.listen(nativeEl, 'pointercancel', end),
      this.renderer.listen(nativeEl, 'mouseup', end),
      this.renderer.listen(nativeEl, 'mouseleave', end),
      this.renderer.listen(nativeEl, 'contextmenu', (e: Event) => {
        e.preventDefault();
      }),
      this.renderer.listen(nativeEl, 'click', clickHandler)
    );
  }

  ngOnDestroy(): void {
    this.hammer?.off('press');
    this.hammer?.destroy?.();
    this.hammer = undefined;

    for (const off of this.removeListeners) {
      try {
        off();
      } catch {}
    }
    this.removeListeners = [];
  }
}